import React, {memo} from "react";
import {Swiper, SwiperSlide} from 'swiper/react';
import {useSelector} from "react-redux";
import swal from 'sweetalert';
import {IMG_DISCOUNT_PUBLIC_URL_SERVER, PUBLIC_URL_SERVER} from "../../../../apis";
import {LazyLoadImage} from "react-lazy-load-image-component";
import SwiperCore, {A11y, Lazy, Navigation, Scrollbar,Autoplay} from "swiper";

SwiperCore.use([Navigation, Scrollbar, A11y, Lazy,Autoplay]);
const SliderAd = () => {
    const {ads} = useSelector(state => state.main.main);

    const handelClickAd = (ad) => {
        swal({
            text: ad.description,
            buttons: {
                cancel: "تایید",
            },
            icon: "info",
        });
    };
    return (
        <div>
            <Swiper
                spaceBetween={0}
                slidesPerView={4}
                breakpoints={{
                    0: {slidesPerView: 1},
                    567: {slidesPerView: 3},
                    1000: {slidesPerView: 4}
                }}
                autoplay={{ delay: 2000 }}
                loop={true}
            >
                {typeof ads !== "undefined" ? ads.map(ad => {
                    return (
                        <SwiperSlide key={ad.id} onClick={() =>handelClickAd(ad)}>
                            <LazyLoadImage
                                style={{width: '100%', height: '100%'}}
                                alt={ad.description}
                                delayTime={3000}
                                src={PUBLIC_URL_SERVER+IMG_DISCOUNT_PUBLIC_URL_SERVER+ad.image}
                                placeholder={<span>درحال بارگزاری ...</span>}
                            />
                            {/*<img style={{width: '100%', height: '100%'}}
                                 src={PUBLIC_URL_SERVER+IMG_DISCOUNT_PUBLIC_URL_SERVER+ad.image} alt="عکس"/>*/}
                        </SwiperSlide>
                    );
                }) : ''}
            </Swiper>
        </div>
    );
};

export default memo(SliderAd);
